const GET_COMMISSION_SUMMARY_BY_ID_STARTED = 'GET_COMMISSION_SUMMARY_BY_ID_STARTED';
const GET_COMMISSION_SUMMARY_BY_ID_SUCCESS = 'GET_COMMISSION_SUMMARY_BY_ID_SUCCESS';
const GET_COMMISSION_SUMMARY_BY_ID_FAIL = 'GET_COMMISSION_SUMMARY_BY_ID_FAIL';
const DELETE_COMMISSION_SUMMARY_BY_ID = 'DELETE_COMMISSION_SUMMARY_BY_ID';
const DELETE_COMMISSION_SUMMARY_BY_ID_SUCCESS = 'DELETE_COMMISSION_SUMMARY_BY_ID_SUCCESS';
const DELETE_COMMISSION_SUMMARY_BY_ID_FAIL = 'DELETE_COMMISSION_SUMMARY_BY_ID_FAIL';
const UPDATE_COMMISSION_SUMMARY_BY_ID_STARTED = 'UPDATE_COMMISSION_SUMMARY_BY_ID_STARTED';
const UPDATE_COMMISSION_SUMMARY_BY_ID_SUCCESS = 'UPDATE_COMMISSION_SUMMARY_BY_ID_SUCCESS';
const UPDATE_COMMISSION_SUMMARY_BY_ID_FAIL = 'UPDATE_COMMISSION_SUMMARY_BY_ID_FAIL';
const TRANSFER_COMMISSION_SUMMARY_BY_ID_STARTED = 'TRANSFER_COMMISSION_SUMMARY_BY_ID_STARTED';
const TRANSFER_COMMISSION_SUMMARY_BY_ID_SUCCESS = 'TRANSFER_COMMISSION_SUMMARY_BY_ID_SUCCESS';
const TRANSFER_COMMISSION_SUMMARY_BY_ID_FAIL = 'TRANSFER_COMMISSION_SUMMARY_BY_ID_FAIL';
const SET_MODAL_OPTIONS = 'SET_MODAL_OPTIONS';

const getCommissionSummaryByID = (request, history) => {
	return {
		type: GET_COMMISSION_SUMMARY_BY_ID_STARTED,
		request,
		history,
	};
};
const getCommissionSummaryByIDSuccess = (response = []) => {
	return {
		type: GET_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		response,
	};
};
const getCommissionSummaryByIDFail = () => {
	return {
		type: GET_COMMISSION_SUMMARY_BY_ID_FAIL,
	};
};

const updateCommissionSummaryByID = (request, history, affiliateId) => {
	return {
		type: UPDATE_COMMISSION_SUMMARY_BY_ID_STARTED,
		request,
		history,
		affiliateId
	};
};
const updateCommissionSummaryByIDSuccess = (response = []) => {
	return {
		type: UPDATE_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		response,
	};
};
const updateCommissionSummaryByIDFail = (errMsg) => {
	return {
		type: UPDATE_COMMISSION_SUMMARY_BY_ID_FAIL,
		errMsg
	};
};

const transferCommissionSummaryByID = (request, history) => {
	return {
		type: TRANSFER_COMMISSION_SUMMARY_BY_ID_STARTED,
		request,
		history,
	};
};
const transferCommissionSummaryByIDSuccess = (response = []) => {
	return {
		type: TRANSFER_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		response,
	};
};
const transferCommissionSummaryByIDFail = () => {
	return {
		type: TRANSFER_COMMISSION_SUMMARY_BY_ID_FAIL,
	};
};

const deleteCommissionSummaryByID = (request, history) => {
	return {
		type: DELETE_COMMISSION_SUMMARY_BY_ID,
		request,
		history,
	};
};
const deleteCommissionSummaryByIDSuccess = (response = []) => {
	return {
		type: DELETE_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		response,
	};
};
const deleteCommissionSummaryByIDFail = () => {
	return {
		type: DELETE_COMMISSION_SUMMARY_BY_ID_FAIL,
	};
};

const setModalOptions = (modalOptions) => {
	return {
		type: SET_MODAL_OPTIONS,
		modalOptions,
	};
};

export default {
	types: {
		GET_COMMISSION_SUMMARY_BY_ID_STARTED,
		GET_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		GET_COMMISSION_SUMMARY_BY_ID_FAIL,
		DELETE_COMMISSION_SUMMARY_BY_ID,
		DELETE_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		DELETE_COMMISSION_SUMMARY_BY_ID_FAIL,
		UPDATE_COMMISSION_SUMMARY_BY_ID_STARTED,
		UPDATE_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		UPDATE_COMMISSION_SUMMARY_BY_ID_FAIL,
		TRANSFER_COMMISSION_SUMMARY_BY_ID_STARTED,
		TRANSFER_COMMISSION_SUMMARY_BY_ID_SUCCESS,
		TRANSFER_COMMISSION_SUMMARY_BY_ID_FAIL,
		SET_MODAL_OPTIONS,
	},
	creators: {
		getCommissionSummaryByID,
		getCommissionSummaryByIDSuccess,
		getCommissionSummaryByIDFail,
		deleteCommissionSummaryByID,
		deleteCommissionSummaryByIDSuccess,
		deleteCommissionSummaryByIDFail,
		updateCommissionSummaryByID,
		updateCommissionSummaryByIDSuccess,
		updateCommissionSummaryByIDFail,
		transferCommissionSummaryByID,
		transferCommissionSummaryByIDSuccess,
		transferCommissionSummaryByIDFail,
		setModalOptions,
	},
};
